'use client';

import { c as _c } from "react/compiler-runtime";
import { SnackbarProvider } from 'notistack';
import { type PropsWithChildren } from 'react';
import { TwoLineSnackbar } from '../components';
declare module 'notistack' {
  interface VariantOverrides {
    twoLine: true;
  }
}
export function SnackbarWrapperProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      twoLine: TwoLineSnackbar
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <SnackbarProvider Components={t1}>{children}</SnackbarProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}